<template>
  <div class="room-warning" :class="{ expanded: isExpanded }" @click="isExpanded = !isExpanded">
    <div>
      <template v-for="(part, $index) in warning.message_list">
        <text-part
          v-if="part.type !== MESSAGE_ITEM_TYPE_ICON"
          :key="`warning-text-${$index}`"
          :partData="part"
        />
        <icon-part
          v-else-if="part.type === MESSAGE_ITEM_TYPE_ICON"
          :key="`warning-icon-${$index}`"
          :partData="part"
        />
      </template>
    </div>
    <div class="ellipsis" v-if="!isExpanded">...</div>
    <div class="expand-icon"></div>
  </div>
</template>

<script lang="ts" setup>
import { ref, Ref, toRef } from 'vue';
import { ICommentData } from '@/service/broadcast/types';
import TextPart from '@/components/comment/comment-list/text-part';
import IconPart from '@/components/comment/comment-list/icon-part';
import {
  MESSAGE_ITEM_TYPE_TEXT,
  MESSAGE_ITEM_TYPE_ICON,
} from '@/constants/comment';

interface IRoomWarningProps {
  warning: ICommentData | null;
}

const props = withDefaults(defineProps<IRoomWarningProps>(), {});

const warning = toRef(props, 'warning');

const isExpanded: Ref<boolean> = ref(false);

</script>


<style lang="less" scoped>
.room-warning {
  display: flex;
  background: #fae9ea;
  border-radius: 6px;
  padding: 8px;
  width: 135px;
  height: 48px;
  overflow: hidden;
  pointer-events: auto;
  cursor: pointer;

  & > div {
    flex-shrink: 1;
    flex-grow: 1;
  }

  .message-text-part {
    display: inline;
    line-height: 16px;
    font-size: 12px;
    vertical-align: top;
    height: 32px;
    color: #ff4747;
  }

  .message-icon-part.warning {
    width: 16px;
    height: 16px;
    display: inline-block;
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
    margin-right: 4px;
  }

  .ellipsis {
    color: #ff4747;
    align-self: flex-end;
  }

  .expand-icon {
    align-self: flex-end;
    background-image: url('@/assets/arrow.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 16px;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    flex-grow: 0;
    margin-left: 4px;
    transform: rotate(-180deg);
  }


  &.expanded {
    width: 100%;
    height: auto;
    animation: twinkle 0.2s 1;

    .expand-icon {
      transform: rotate(0);
    }
  }

  @keyframes twinkle{
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }

  @-webkit-keyframes twinkle {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }


}
</style>